/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicostsdailytitle3Inputs */

const en_aicostsdailytitle3 = /** @type {(inputs: Aicostsdailytitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost over the last 30 days`)
};

const de_aicostsdailytitle3 = /** @type {(inputs: Aicostsdailytitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosten der letzten 30 Tage`)
};

/**
* | output |
* | --- |
* | "Cost over the last 30 days" |
*
* @param {Aicostsdailytitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostsdailytitle3 = /** @type {((inputs?: Aicostsdailytitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostsdailytitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostsdailytitle3(inputs)
	return de_aicostsdailytitle3(inputs)
});
export { aicostsdailytitle3 as "aiCostsDailyTitle" }